import powderFreeNitrileGloves from '../../assets/powder-free-nitrile-gloves-small.webp';
import nitrileGloves from '../../assets/nitrile-gloves-small.webp';
import nitrileExamGloves from '../../assets/nitrile-exam-gloves.webp';
import blueNitrileGloves from '../../assets/blue-nitrile-gloves.webp';

export const nitrileGlovesProducts = [
    {
        image: powderFreeNitrileGloves,
        alt: 'Powder Free Nitrile Gloves'
    },
    {
        image: nitrileGloves,
        alt: 'Nitrile Gloves'
    },
    {
        image: nitrileExamGloves,
        alt: 'Nitrile Exam Gloves'
    },
    {
        image: blueNitrileGloves,
        alt: 'Blue Nitrile Gloves'
    }
]; 